import { render, staticRenderFns } from "./PilotsOverview.vue?vue&type=template&id=4f3267da&scoped=true&"
import script from "./PilotsOverview.vue?vue&type=script&lang=ts&"
export * from "./PilotsOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3267da",
  null
  
)

export default component.exports